/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const resolvePendingDmBodyIdentifierMin = 3;
export const resolvePendingDmBodyIdentifierMax = 320;

export const ResolvePendingDmBody = zod.object({
  identifier: zod
    .string()
    .min(resolvePendingDmBodyIdentifierMin)
    .max(resolvePendingDmBodyIdentifierMax)
    .describe(
      'The email or E.164 phone the caller is composing to. Normalized server-side to the ledger form (lowercased email \/ E.164 phone), identically to invitation issuance.',
    ),
});

export type ResolvePendingDmBody = zod.input<typeof ResolvePendingDmBody>;
export type ResolvePendingDmBodyOutput = zod.output<typeof ResolvePendingDmBody>;
